import { PROMPT_TAG } from 'common/tags'

import ZoidGenerator from 'wrapper/lib/frames/utils/ZoidGenerator'
import AttachIFrame from 'wrapper/lib/frames/utils/AttachIFrame'

import { hideFrameStyles, showPromptAndMenuFrameStyles } from 'wrapper/lib/frames/utils/frameDisplayStyles'

const Prompt = (data = {}) => {
    const promptElement = document.getElementById(PROMPT_TAG)

    if (promptElement) {
        Object.assign(promptElement.style, showPromptAndMenuFrameStyles)
        promptElement.setAttribute('visible', '')

        return promptElement
    }

    const style = {
        position: 'fixed',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        zIndex: '-999999',
        ...hideFrameStyles,
    }

    const prompt = ZoidGenerator({
        tag: PROMPT_TAG,
        url: `https://${process.env.HOSTNAME}/prompt/index.${process.env.DATE_HASH}.html`,
        containerStyle: {
            width: '100vw',
            height: '100vh',
        },
        frameStyle: {
            width: '100%',
            height: '100%',
        },
    })

    return AttachIFrame({
        id: PROMPT_TAG,
        data,
        zoid: prompt,
        style,
    })
}

export default Prompt
